<template>
  <span>
    <Icon
      class="cursor-pointer start-chat-social mx-3"
      name="chat"
      @click.native="openPopoverChat"
    />
    <Icon
      class="cursor-pointer start-chat-social-sm mx-3"
      name="chat"
      @click.native="openChat"
    />
  </span>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import Icon from '@/components/atoms/Icon';

export default {
  name: 'ConversationButton',
  components: {
    Icon,
  },
  data() {
    return {
      isChatLoading: false,
    };
  },
  computed: {
    ...mapState('current', ['accountId']),
  },
  methods: {
    ...mapMutations(['setActivePopoverChat']),
    ...mapActions(['getConversationInfo', 'errorNotify']),
    openPopoverChat() {
      this.isChatLoading = true;
      this.getConversationInfo({ conversationId: this.accountId })
        .then(({ id }) => {
          this.setActivePopoverChat(id);
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.isChatLoading = false;
        });
    },
    openChat() {
      this.isChatLoading = true;
      this.getConversationInfo({ conversationId: this.accountId })
        .then(res => {
          this.$router.push({
            name: 'conversations',
            params: {
              id: res.id,
            },
          });
        })
        .catch(err => {
          this.errorNotify(err);
          this.$router.push({
            name: 'conversations',
          });
        });
    },
  },
};
</script>
<style lang="scss">
.start-chat-social-sm {
  display: none !important;
}
@media (max-width: 767px) {
  .start-chat-social {
    display: none !important;
  }
  .start-chat-social-sm {
    display: inline !important;
  }
}
</style>
